// This file transforms Shopify blog article data into the Recipe format used by the application

import { ShopifyArticle, Recipe } from '../../types/shopify';

/**
 * Transforms a Shopify article into the Recipe format used by the application
 */
export const transformShopifyArticleToRecipe = (article: ShopifyArticle): Recipe => {
  try {
    // console.log('Transforming Shopify article:', article.id, article.title);
    
    // Transform to the expected Recipe format
    const recipe: Recipe = {
      id: article.id,
      title: article.title,
      handle: article.handle,
      excerpt: article.excerpt || '',
      content: article.content,
      contentHtml: article.contentHtml,
      publishedAt: article.publishedAt,
      image: article.image,
      author: article.author,
      tags: article.tags || [],
      blogHandle: article.blogHandle
    };
    
    // console.log('Successfully transformed article to recipe:', recipe.title);
    return recipe;
  } catch (error) {
    console.error('Error transforming Shopify article:', error);
    // Return a minimal valid Recipe object to prevent app crashes
    return {
      id: article.id || 'error-id',
      title: article.title || 'Error loading recipe',
      handle: article.handle || 'error-handle',
      content: '',
      contentHtml: '',
      publishedAt: new Date().toISOString(),
      tags: []
    };
  }
};

/**
 * Transforms an array of Shopify articles into an array of Recipe objects
 */
export const transformShopifyArticlesToRecipes = (articles: ShopifyArticle[]): Recipe[] => {
  // console.log(`Transforming ${articles.length} Shopify articles to recipes`);
  
  if (!Array.isArray(articles)) {
    console.error('articles is not an array:', articles);
    return [];
  }
  
  const transformedRecipes = articles.map(article => {
    try {
      return transformShopifyArticleToRecipe(article);
    } catch (error) {
      console.error('Error transforming article:', error);
      return null;
    }
  }).filter(recipe => recipe !== null) as Recipe[];
  
  // console.log(`Successfully transformed ${transformedRecipes.length} articles to recipes`);
  return transformedRecipes;
};
